import { render, staticRenderFns } from "./WarningMessage.vue?vue&type=template&id=539d09f5&scoped=true&"
import script from "./WarningMessage.vue?vue&type=script&lang=js&"
export * from "./WarningMessage.vue?vue&type=script&lang=js&"
import style0 from "./WarningMessage.vue?vue&type=style&index=0&id=539d09f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539d09f5",
  null
  
)

export default component.exports